//  The function is used exclusively for the onboarding test variants.
//  Should be removed after the tests are complete.
export default () => {
    const experimentStyles = '.RC-phone:not(.RC-tablet):not(.RC-desktop) .RC-bookieSelection{display:flex;align-items:center;justify-content:space-between;float:initial;height:46px;margin:0 7px 7px;background-color:rgba(255,255,255,.1);padding:7px}.RC-phone:not(.RC-tablet):not(.RC-desktop) .RC-bookieSelection__label{position:relative;top:0;right:0;font-size:12px;font-family:proxima-nova-a-bold, sans-serif;color:#fff;text-transform:none}.RC-phone:not(.RC-tablet):not(.RC-desktop) .RC-bookieSelection__button{margin-right:0}.RC-phone:not(.RC-tablet):not(.RC-desktop) .RC-bookieSelection__buttonIcon{display:none}.RC-phone:not(.RC-tablet):not(.RC-desktop) .RC-cardTabsZone{height:94px}.RC-phone:not(.RC-tablet):not(.RC-desktop) .RC-cardTabsZone__link{margin:0;padding:2px 16px;border-right:1px solid #fff}.RC-phone:not(.RC-tablet):not(.RC-desktop) .RC-cardTabsZone__link:last-of-type{border-right:none}';
    const headTag = document.head || document.getElementsByTagName('head')[0];
    const styleTag = document.createElement('style');

    styleTag.type = 'text/css';

    if (styleTag.styleSheet) {
        styleTag.styleSheet.cssText = experimentStyles;
    } else {
        styleTag.appendChild(document.createTextNode(experimentStyles));
    }

    headTag.appendChild(styleTag);
};



// WEBPACK FOOTER //
// ./lib/js/modules/bookieSelection/experimentStyles.js